import axios from '@/api/$axios'
export default {
  list ({ page, perPage, kw, teacherId, category }) {
    return axios.get(`/teachers/${teacherId}/videos`, {
      params: {
        category, page, perPage, title: kw
      }
    })
  },
  listByCourse ({ page, perPage, kw, courseId }) {
    return axios.get(`/courses/${courseId}/videos`, {
      params: {
        page, perPage, title: kw
      }
    })
  },
  detail ({ id }) {
    return axios.get(`/videos/${id}`)
  }
}
